"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _emotionTheming = require("emotion-theming");

var s = _interopRequireWildcard(require("./PieChart.style"));

var getSectors = function getSectors(props) {
  var totalValue = 0;
  var radius = props.size / 2;
  var circleLength = Math.PI * (radius * 2);
  var spaceLeft = circleLength;

  for (var i = 0; i < props.sectors.length; i += 1) {
    totalValue += props.sectors[i].count;
  }

  var a = [];
  a.push(_react.default.createElement("circle", {
    cx: "100",
    cy: "100",
    r: "75",
    style: {
      strokeDasharray: '471.239, 471.239',
      stroke: '#c5d0de',
      fill: 'none',
      strokeWidth: props.mode === 'dark' ? 20 : 45
    }
  }));

  for (var _i = 0; _i < props.sectors.length; _i += 1) {
    a.push(_react.default.createElement("circle", {
      cx: "100",
      cy: "100",
      r: props.size / 2,
      style: {
        strokeDasharray: spaceLeft + ' ' + circleLength,
        stroke: props.sectors[_i].count ? props.sectors[_i].color : 'transparent',
        fill: 'none',
        strokeWidth: props.mode === 'dark' ? 20 : 45
      }
    }));
    spaceLeft -= props.sectors[_i].count / totalValue * circleLength;
  }

  return a;
};

var PieChart = function PieChart(props) {
  return _react.default.createElement("div", {
    className: (0, _classnames.default)(s.root(), props.className)
  }, _react.default.createElement("svg", {
    className: s.styles(props.size, props.theme, props.mode)
  }, getSectors(props)), _react.default.createElement("div", {
    className: s.pieChartData(props.mode)
  }, props.sectors.map(function (sector, i) {
    var key = i + 1;

    var singleText = _react.default.createElement("div", {
      className: s.singlePieChartField(props.mode),
      key: key
    }, _react.default.createElement("div", {
      className: s.colorDiv(sector.color, props.mode)
    }), _react.default.createElement("div", {
      className: s.textStyles(props.theme, props.mode)
    }, "".concat(sector.label, " (").concat(sector.count, ")")));

    return singleText;
  })));
};

PieChart.defaultProps = {
  size: 150,
  sectors: [],
  className: '',
  mode: 'light'
};
PieChart.propTypes = {
  size: _propTypes.default.number,
  sectors: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    color: _propTypes.default.string,
    count: _propTypes.default.number
  })),
  className: _propTypes.default.string,
  mode: _propTypes.default.oneOf(['dark', 'light'])
};

var _default = (0, _emotionTheming.withTheme)(PieChart);

exports.default = _default;